import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Challenges() {
  const challenges = [{
    title: 'Залежність від команди',
    desc: 'Ви відчуваєте себе залежними від маркетингової команди або підрядників і не контролюєте логіку рішень'
  }, {
    title: 'Маркетинг без системи',
    desc: 'Маркетинг у компанії існує у вигляді окремих дій, але не зведений в єдину керовану модель'
  }, {
    title: 'Немає сильного CMO',
    desc: 'Ви не можете знайти керівника з маркетингу, який здатен побудувати процеси'
  }, {
    title: 'Команди без мислення',
    desc: 'Ви працюєте з командами, що використовують інструменти, але не розуміють, як це впливає на бізнес'
  }, {
    title: 'Перевантаження інформацією',
    desc: 'Курсів і порад стало занадто багато, і управління бізнесом ускладнюється, а не спрощується'
  }, {
    title: 'Відчуття стелі',
    desc: 'Є відчуття, що потенціал бізнесу вищий, ніж поточні результати маркетингу'
  }, {
    title: 'Ви в рутині',
    desc: 'Ви постійно залучені в операційні рішення і не маєте часу працювати на рівні стратегії'
  }, {
    title: 'Масштаб без ясності',
    desc: 'Ви розумієте, що бізнес можна масштабувати інакше, але не бачите чіткої логіки наступного кроку'
  }];
  return <Section className="bg-transparent" data-id="element-72">
      <div className="text-center mb-16" data-id="element-73">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-74">
          Ключові виклики бізнесу у{' '}
          <span className="text-red-500" data-id="element-75">2026 році</span>
        </h2>
        <p className="text-xl text-gray-400" data-id="element-76">Перевірте, чи впізнаєте Ви себе</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 mb-16" data-id="element-77">
        {challenges.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.05
      }} className="group" data-id="element-78">
            {/* Title in bordered box with red hover */}
            <div className="inline-block mb-4" data-id="element-79">
              <h3 className="text-lg font-bold text-white px-4 py-2 border border-white/30 rounded-full transition-colors duration-300 group-hover:border-red-500/60 group-hover:text-red-400" data-id="element-80">
                {item.title}
              </h3>
            </div>
            {/* Description without border */}
            <p className="text-sm text-gray-400 leading-relaxed pl-1" data-id="element-81">
              {item.desc}
            </p>
          </motion.div>)}
      </div>

      <div className="max-w-3xl mx-auto text-center bg-gradient-to-r from-purple-900/20 to-blue-900/20 p-8 rounded-2xl border border-purple-500/20" data-id="element-82">
        <p className="text-lg text-gray-200 mb-8" data-id="element-83">
          Якщо Ви відмітили 2 або більше пунктів, Вашому бізнесу не потрібна ще
          одна тактика чи інструмент. Потрібен інший рівень управлінських рішень
          власника.
        </p>
        <Button href="#tariffs" variant="primary" size="lg" data-id="element-84">
          Розпочати зміни
        </Button>
      </div>
    </Section>;
}